// extracted by mini-css-extract-plugin
module.exports = {"container":"about_container__49usF","framecv":"about_framecv__2o--1"};